module.exports = __webpack_public_path__ + "media/images/article/2022_05_a-ab9f5654ee4472e9cfbfc65eca6a41da.png";